import type { Event } from '@sentry/angular'

// Leaves room for the envelope headers under the 1 MB body limit of the nginx in front of the Sentry tunnel.
export const MAX_TRANSACTION_BYTES = 900_000

const endsBeforeItStarts = (start: number | undefined, end: number | undefined): boolean =>
  start === undefined || end === undefined || end < start

/**
 * Prepares a transaction for the Sentry tunnel: drops the spans Sentry would reject the whole transaction for, and
 * returns null when the transaction itself has broken timestamps or would not fit through the tunnel.
 */
export function filterTransactionForTunnel<T extends Event>(event: T): T | null {
  if (endsBeforeItStarts(event.start_timestamp, event.timestamp)) {
    return null
  }
  const spans = event.spans?.filter((span) => !endsBeforeItStarts(span.start_timestamp, span.timestamp))
  const filtered = spans ? { ...event, spans } : event
  const bytes = new TextEncoder().encode(JSON.stringify(filtered)).length
  return bytes > MAX_TRANSACTION_BYTES ? null : filtered
}
